import styled from "styled-components";

export const BackButtonWrapper = styled.div`
  color: #515151;
  font-weight: 700;
  margin-bottom: 1.5rem;

  & > a {
    display: flex;
  }

  & > a > svg {
    transition: transform 0.3s ease;
    margin-right: 0.5rem;
  }

  & > a:hover > svg {
    transform: translateX(-50%);
  }
`;
